import { bool, func, object } from 'prop-types';
import React, { useMemo } from 'react';
import { useForm, useFormState } from 'react-final-form';
import './FormButtons.less';
const FormButtons = (props) => {
    const formApi = useForm();
    const { renderButtons, disabled, subscription } = props;
    const formStateArg = useMemo(() => {
        const result = {};
        if (typeof subscription === 'object') {
            result.subscription = Object.assign(Object.assign({}, subscription), { submitting: true, pristine: true });
        }
        return result;
    }, [subscription]);
    const formState = useFormState(formStateArg);
    const { submitting } = formState;
    if (typeof renderButtons === 'function') {
        return React.createElement("div", { className: 'kal-form-buttons' }, renderButtons(disabled || submitting, formState, formApi));
    }
    return null;
};
FormButtons.propTypes = {
    renderButtons: func,
    disabled: bool,
    subscription: object,
};
export default FormButtons;
//# sourceMappingURL=FormButtons.js.map